<template>
  <div class="home">
    <div class="mb-4 heading slider-align mt-4">
      <!-- <div class="">Shop by Category</div> -->
      <!-- :theme="theme" -->
      <sections-slider
        v-if="showCategory && marketListData && marketListData.length"
        :loading="isLoading"
        :list="marketListData"
        subTitle="Our Category"
        :hasInnerBackground="true"
        :hasButton="false"
        :showTitle="true"
        :withSlider="true"
      >
        <template slot="default" slot-scope="{ listItem }">
          <div class="item-box">
            <items-item
              :itemLogo="true"
              :product="listItem"
              :incrementDecrementKey="false"
              :marketRoute="{
                name: `category-item`,
                params: {
                  data: listItem.name,
                },
              }"
            ></items-item>
          </div>
        </template>
      </sections-slider>
    </div>

    <!-- <b-container>
      <h3 class="subtitle-style">Bill Payment</h3>
      <div>
        <b-col
          md="4"
          class="bill-market-section"
          v-for="category in billCategoryList"
          :key="category._id"
        >
          <router-link
            class="bill-payment-link"
            :to="{
              name: category.name,
              params: { category: category.name },
            }"
          >
            <div class="d-flex align-items-center bill-payment-box">
              <b-img
                class="bill-image mr-5"
                :src="
                  category && category.images ? category.images.thumbnail : ''
                "
              ></b-img>
              <p>{{ category ? category.name : "" }}</p>
            </div>
          </router-link>
        </b-col>
      </div>
    </b-container> -->
    <!-- <div class="red pt-1 pb-3 heading"> -->
    <!-- <sections-slider
        v-if="newStore && newStore.length"
        :list="newStore"
        subTitle="New Stores"
        :hasBackground="false"
        :showTitle="true"
        :hasButton="true"
        class="stores-slider mobile-view-stores"
        :withoutSlider="true"
        :maxItems="4"
        :viewMorePage="{
          name: `product-listing`,
          params: {
            items: `New Stores`,
          },
        }"
      >
        <template slot="default" slot-scope="{ listItem }">
          <div class="item-box">
            <router-link
              style="text-decoration: none; color: inherit"
              :to="{
                name: `shopDetails`,
                params: {
                  id: listItem._id,
                  items: listItem.office.officeName,
                },
              }"
            >
              <items-item
                :itemWhiteBg="true"
                :product="listItem"
                class="store-div"
              ></items-item>
            </router-link>
          </div>
        </template>
      </sections-slider> -->
    <!-- </div> -->
    <!-- <div v-if="inStock && inStock.length" class="green pt-1 pb-3 heading">
      <product-detail v-for="(item, i) in inStock" :key="i" :id="item._id" />
    </div> -->
    <div class="blue pt-1 pb-3 heading mb-4">
      <!-- <sections-slider
        v-if="outOfStock && outOfStock.length"
        :list="outOfStock"
        subTitle=""
        :showTitle="true"
        :hasBackground="false"
        :hasButton="true"
        class="suggested-slider"
        :withoutSlider="true"
        :viewMorePage="{
          name: `new-arrivals-listing`,
          params: {
            items: `New Arrivals`,
          },
        }"
      >
        <template slot="default" slot-scope="{ listItem }">
          <div class="item-box">
            <items-item
              :itemNoBg="true"
              :product="listItem"
              :incrementDecrementKey="true"
              class="suggester-div"
              :showGoToCart="true"
            >
            </items-item>
          </div>
        </template>
      </sections-slider> -->
    </div>
    <div class="suggested-yellowLight pt-1 pb-3 heading">
      <sections-slider
        :list="newArrivals"
        :loading="isLoading"
        subTitle="New Arrivals"
        :hasBackground="false"
        :showTitle="true"
        :hasButton="true"
        class="suggested-slider"
        :withoutSlider="true"
        :viewMorePage="{
          name: `new-arrivals-listing`,
          params: {
            items: `New Arrivals`,
          },
        }"
      >
        <template slot="default" slot-scope="{ listItem }">
          <div class="item-box">
            <items-item
              :itemNoBg="true"
              :product="listItem"
              :incrementDecrementKey="true"
              class="suggester-div"
            >
            </items-item>
          </div>
        </template>
      </sections-slider>
    </div>
    <div class="suggested-yellowLight pt-1 pb-3 heading">
      <sections-slider
        v-if="itemSuggestions && itemSuggestions.length"
        :loading="isLoading"
        :list="itemSuggestions"
        subTitle="Suggested For You"
        :hasBackground="false"
        :showTitle="true"
        :hasButton="true"
        class="suggested-slider"
        :withoutSlider="true"
        :viewMorePage="{
          name: `product-listing`,
          params: {
            items: `Suggested For You`,
          },
        }"
      >
        <template slot="default" slot-scope="{ listItem }">
          <div class="item-box">
            <items-item
              :itemNoBg="true"
              :product="listItem"
              :incrementDecrementKey="true"
              class="suggester-div"
            >
            </items-item>
          </div>
        </template>
      </sections-slider>
    </div>

    <!-- place holder -->
    <!-- <div>
			<b-container>
				<template
					v-if="$options.components['advertisement-home-offer-middle']"
				>
					<advertisement-home-offer-middle />
				</template>
			</b-container>
		</div> -->
    <!-- end -->

    <div class="purpleLight pt-1 pb-3 heading">
      <sections-slider
        v-if="trendingItems && trendingItems.length"
        :loading="isLoading"
        :list="trendingItems"
        subTitle="What's Trending"
        :showTitle="true"
        :hasBackground="false"
        :hasButton="true"
        class="suggested-slider"
        :withoutSlider="true"
        :viewMorePage="{
          name: `product-listing`,
          params: {
            items: `What's Trending`,
          },
        }"
      >
        <template slot="default" slot-scope="{ listItem }">
          <div class="item-box">
            <items-item
              :itemNoBg="true"
              :product="listItem"
              :incrementDecrementKey="true"
              class="suggester-div"
            >
            </items-item>
          </div>
        </template>
      </sections-slider>
    </div>

    <!-- Place holder -->
    <!-- <div>
			<b-container>
				<template v-if="$options.components['advertisement-middle-banner']">
					<advertisement-middle-banner />
				</template>
			</b-container>
		</div> -->
    <!-- end of Place holder -->

    <!-- best picks section starts -->
    <!-- <div
			v-for="marketItem in Object.keys(marketListData).filter(key => marketListData[key].length > 0)"
			:key="marketItem"
			class="pt-1 pb-3 market-subhead"
		>
			<sections-slider
				v-if="marketListData[marketItem].length"
				:viewMorePage="
					marketItem === 'Clothes & Fashion'
						? { name: 'fashionMarket', params: { product: listItem } }
						: { name: 'market-view', params: { market: marketItem } }
				"
				:list="marketListData[marketItem]"
				:subTitle="marketItem"
				:hasButton="true"
				:onlyTitle="true"
				:showTitle="true"
				:itemSubTitle="true"
				:hasBackground="false"
				class="suggested-slider"
				:withoutSlider="true"
			>
				<template slot="default" slot-scope="{ listItem }">
					<div class="item-box">
						<items-item
							:itemNoBg="true"
							:product="listItem"
							:incrementDecrementKey="true"
							class="suggester-div"
						>
						</items-item>
					</div>
				</template>
			</sections-slider>
		</div> -->
    <!-- end of best picks section -->

    <b-modal
      id="bv-add-address"
      size="lg"
      centered
      title=""
      hide-header
      hide-footer
      v-if="!shouldHideModal"
    >
      <v-container>
        <add-address-modal />
      </v-container>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import addAddressModal from "../../../address/components/add-address-modal.vue";
// import ProductDetail from "../../components/productDetail.vue";
export default {
  components: { addAddressModal },
  data() {
    return {
      billMarketId: null,
      shouldHideModal: true,
      listItem: null,
      isLoading: false,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.auth.userInfo,
      trendingItems: (state) => state["home"].trendingItems,
      itemSuggestions: (state) => state["home"].itemSuggestions,
      newArrivals: (state) => state["home"].newArrivals,
      inStock: (state) => state["home"].inStock,
      outOfStock: (state) => state["home"].outOfStock,
      newStore: (state) => state["home"].newStores,
      marketList: (state) => state["home"].marketList,
      marketListData: (state) => state["home"].marketList,
      currentPosition: (state) => state.location.currentPosition,
      homeLocation: (state) => state["home"].defaultLocation,
      billCategoryList: (state) => state["home"].billCategoryList,
      billMarketRouterName: (state) => state["home"].billMarketRouterName,
      isLoggedin: (state) => state.auth.isLoggedin,
      tenantConfig: (state) => state.home.tenantConfig,
    }),
    showCategory() {
      return this.tenantConfig?.buildConfig?.web?.dynamicFields?.categorySection
        ? this.tenantConfig?.buildConfig?.web?.dynamicFields?.categorySection
        : false;
    },
  },
  watch: {
    homeLocation() {
      this.fetchStore();
    },
  },
  methods: {
    ...mapActions({
      fetchAllItemsData: "home/fetchAllItems",
      fetchNewStoreData: "home/fetchNewStores",
      fetchMarketItemsData: "home/fetchMarketItemsData",
      fetchMarket: "home/fetchMarketList",
      fetchBillPaymentCategoryData: "home/fetchBillPaymentCategoryData",
      fetchWishlist: "wishlist/listWishList",
    }),
    fetchStore() {
      const payload = {
        category: "SELLER",
        name: "",
        state: "",
        city: "",
        zip: "",
        street: "",
        market: "",
        lat: this.currentPosition?.Lat || 0,
        lng: this.currentPosition?.Lng || 0,
        radius: 6000,
        // newlyAdded: "n",
        refresh: true,
      };
      this.fetchNewStoreData(payload);
    },
    getBackgroundColor(marketItem) {
      if (marketItem in this.marketListData) {
        switch (marketItem) {
          case "Electronics":
            return { backgroundColor: "#FFE1D5" };
          case "Education":
            return { backgroundColor: "#D8D6E7" };
          case "Grocery":
            return { backgroundColor: "#FAEDCC" };
          case "Pharmacy1":
            return { backgroundColor: "#D6E9FA" };
          case "Clothes & Fashion":
            return { backgroundColor: "#EFDFEB" };
          case "Health Care":
            return { backgroundColor: "#CCE0FF" };
          case "Tour & Travels":
            return { backgroundColor: "#DBF7FC" };
          case "Home Service":
            return { backgroundColor: "#E5D8EC" };
          case "Rental Service":
            return { backgroundColor: "#CFCCE1" };
          case "Recharge & Payments":
            return { backgroundColor: "#FCCCDD" };
          case "Fruit & Vegetables":
            return { backgroundColor: "#D9EBD3" };
          case "Spare Hub":
            return { backgroundColor: "#F9D4D5" };
          case "Food & Restaurant":
            return { backgroundColor: "#FEE7D3" };
          case "Telecom":
            return { backgroundColor: "#E6D2CE" };
          default:
            return { backgroundColor: "white" };
        }
      } else {
        // return empty object if marketItem doesn't exist
        return {};
      }
    },
    async fetchItemsData() {
      await this.fetchAllItemsData();
    },
    fetchMarketdata() {
      this.fetchMarketItemsData();
    },
    fetchBillPaymentCategory() {
      this.fetchBillPaymentCategoryData();
    },
    //setBillMarketId() {
    //   const selectBillMarket = this.marketList.find(
    //     (e) => e.name === "Bill Payment"
    //   );
    //   this.billMarketId = selectBillMarket._id;
    // },
    addAccount() {
      this.$bvModal.hide("bv-add-address");
      this.$router.push("/cashback-accounts");
    },
  },
  async mounted() {
    //await this.setBillMarketId();
    // await this.fetchBillPaymentCategory();
    // try {
    // 	await this.$store.dispatch(
    // 		"profile/getAccountDetails",
    // 		this.userInfo._id
    // 	);
    // } catch (error) {
    // 	//this.$bvModal.show("bv-add-address");
    // 	this.$store.state["home"].showCashbackPopup = false;
    // }
    // await this.fetchMarketdata();
    this.isLoading = true;
    this.fetchStore();
    // if (
    //   this.$store.state["home"].itemSuggestions.length === 0 ||
    //   this.$store.state["home"].newArrivals.length === 0 ||
    //   this.$store.state["home"].trendingItems.length === 0
    // ) {
    // }
    await this.fetchItemsData();
    this.isLoading = false;
    if (this.isLoggedin) this.fetchWishlist();
    const address_popup = localStorage.getItem(
      `${process.env.VUE_APP_TENANT}:address_popup`,
    );
    if (!address_popup) {
      this.shouldHideModal = false;
    }
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
};
</script>
<style scoped>
.market-subhead h3 {
  font-size: 16px;
}

.slider-align {
  background-color: var(--secondarylight);
  margin-bottom: 36px;
}

.slider {
  height: 50px;
  margin: 16px 0 0;
  padding: 10px 0 20px;
}

.red {
  background: var(--secondaryLight);
}

.blue {
  /* background: var(--primarylight); */
}

.green {
  /* background: var(--primarylight); */
}

.suggested-yellowLight {
  /* background: #fcffec; */
}

.purpleLight {
  /* background: #f8eeff; */
}

.yellow {
  /* background: var(--primarylight); */
}

/* .bill-market-section {
  display: inline-block;
}
.subtitle-style {
  font-size: 21px;
  font-weight: 500;
  margin-bottom: 0.5rem;
  line-height: 1.2;
} */
/* .bill-payment-box {
  background:background: #FFE2C9;
;
  color: #272727;
  border-radius: 5px;
  border: 1px solid #19e4c2;
  position: relative;
  z-index: 0;
}
.bill-payment-box:hover {
  border: 1px solid #272727;
  color: #272727;
}
.bill-payment-box::before {
  position: absolute;
  background: #d9f6ff;
  width: 100px;
  content: "";
  height: 80px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.bill-payment-box:hover::before {
  position: absolute;
  background: #272727;
  width: 100px;
  content: "";
  height: 80px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
} */
.bill-payment-link {
  text-decoration: none;
  color: #272727;
}

.bill-payment-box p {
  font-size: 1.1em;
  font-weight: 500;
  margin-bottom: 0;
}

.bill-img-box {
  box-sizing: content-box !important;
}

.bill-image {
  width: 80px;
  padding: 10px;
  z-index: 2;
}

.stores-slider .item-box {
  margin: 0 12px;
  width: 208px;
}

.suggested-slider .item-box {
  margin: 0;
  /* width: 266px; */
  display: block;
}

.store-div:hover {
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.12);
}

.marketitem-slider .item-box {
  margin: 0 12px;
  width: 208px;
  display: block;
}

@media (max-width: 768px) {
  .v-slide-group__next,
  .v-slide-group__prev {
    display: none !important;
  }

  .marketitem-slider .item-box {
    width: 266px;
  }

  .stores-slider .item-box {
    margin: 0 12px;
    width: 136px;
  }
}
</style>
